module.exports = __webpack_public_path__ + "static/media/dollar_icon.fee959c5.png";